
import Network from 'infrastructure/js/modules/network';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import * as assetService from '../../../services/Assets/assetService.js';
import * as locationsService from '../../../services/Locations/locationsService';


/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  SCANASSET_PAGE_SUBMIT_IN_PROGRESS:  'SCANASSET_PAGE_SUBMIT_IN_PROGRESS',
  SCANASSET_PAGE_SUBMIT_FINISHED: 'SCANASSET_PAGE_SUBMIT_FINISHED',
  SCANASSET_PAGE_SUBMIT_FAILED: 'SCANASSET_PAGE_SUBMIT_FAILED',
  SCANASSET_PAGE_CLEAR: 'SCANASSET_PAGE_CLEAR',
  // SCANASSET_PAGE_DATA_FETCHED: 'SCANASSET_PAGE_DATA_FETCHED',
};


////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  subminInProgress: function() {
    return {type: actionTypes.SCANASSET_PAGE_SUBMIT_IN_PROGRESS};
  },
  submitFinished: function(payload) {
    return {type: actionTypes.SCANASSET_PAGE_SUBMIT_FINISHED, payload: payload};
  },
  submitFailed: function(payload) {
    return {type: actionTypes.SCANASSET_PAGE_SUBMIT_FAILED, payload: payload};
  },
  clear: function(payload) {
    return {type: actionTypes.SCANASSET_PAGE_CLEAR, payload: payload};
  },
  // dataFetched: function(payload) {
  //   return {type: actionTypes.SCANASSET_PAGE_DATA_FETCHED, payload: payload};
  // },
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function() {
  return function(dispatch, getState) {
    return api.fetchPageData(dispatch, getState)();
  };
};

jsxActions.fetchAsset = function(id, callback) {
  return function(dispatch, getState) {
    api.fetchAsset(dispatch, getState)(id, callback);
  };
};

jsxActions.submit = function(data, callback) {
  return function(dispatch, getState) {
    api.submit(dispatch, getState)(data, callback);
  }
};

jsxActions.clear = function() {
  return function(dispatch, getState) {
    dispatch(actions.clear());
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.fetchPageData = function(dispatch, getState) {
  return function() {

    return locationsService.fetchActiveLocations()
      .then((response) => {
        if (!Network.isResponseValid(response)) {
          console.error("Fetch Locations Failed");
          return {success: false};
        }

        return  response?.dataList
        // const payload =  response?.dataList.map(item => {return {value: item.id, label: item.name}});
        // dispatch(actions.dataFetched(payload));
      });

  }
};

api.fetchAsset = function(dispatch, getState) {
  return function(assetBusinessId, callback) {

    dispatch(actions.subminInProgress());

    // return rollService.getRollByBusinessId({businessId: assetBusinessId} )
    return assetService.getAssetDetails({assetBusinessId} )
      .then ((response) => {

        if (!Network.isResponseValid(response)) {
          console.error('Fetch asset details by businessId failed');
          let message = createLabelHelper('mat.mobile.scanAssetPage.').get('result.barcodeNotFound');
          dispatch(actions.submitFailed(message));

          return {success: false};
        }

        // dispatch(actions.submitFailed('Roll barcode not found'));
        // return {success: false};
        // let payload = response.data && response.dataList.length > 0 ? response.dataList[0] : null;
        dispatch(actions.submitFinished(response.data));

        if (callback) {
          callback(response.data);
        }

      });
  }
};


/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS






